
import _ from 'lodash';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import Table from '../../../../../../common/components/table';


export const RateCardValuesComponent = ({
  handleDelete, additionButtons, handleEdit, columnDefs, pinCodes, selectedRateCards, onInnerBasicFormChange, selectedRateCardValues,
}: any) => {


  return (
    <>
      <AccordionContainer
        child={
          <div className=' h-16 grid grid-cols-1 gap-4'>
            <InputContainer
              label="PIN CODE"
              labelField="Code"
              list={pinCodes}
              onValueChange={(newValue: any) => {
                const pinCodeData: any = newValue.map((option: any) => option?.value || '')
                onInnerBasicFormChange(
                  pinCodeData,
                  'PINCode'
                )
              }}
              type="multiselect"
              valueField="Code"
              value={selectedRateCards?.PINCode}
            />
          </div>
        }
        expandedPanel="servicability"
        headerTitle="Servicability Check"
      />

      <div className="w-full">
        <Table columnData={columnDefs} rowData={selectedRateCardValues}
          onEdit={handleEdit} headingName="RateCard Rules Details"
          additionButtons={additionButtons} onDelete={handleDelete} />
      </div>
    </>
  )
}
export default RateCardValuesComponent;
